export default __webpack_public_path__ + "static/media/sad-puppy.bf332768.png";